import { GqlLocation } from "~/graphql-client";
import { Location } from "~/types";

export function mapLocation(location: GqlLocation): Location {
  const {
    name,
    id,
    uid,
    address,
    website,
    coords,
    openingHours,
    phoneNumber,
    social,
    slug,
    orderAheadEnabled,
    orderAtTableEnabled,
    orderDeliveryEnabled,
    timezone,
  } = location;
  const {
    street = null,
    locality = null,
    region = null,
    postalCode = null,
    country = null,
  } = address || {};

  const { facebook = null, instagram = null, twitter = null } = social || {};

  return {
    ref: slug || id,
    uid,
    name,
    openingHours,
    phoneNumber,
    address: address ? { street, locality, region, postalCode, country } : null,
    website: website || null,
    coords: coords
      ? {
          latitude: coords.latitude,
          longitude: coords.longitude,
        }
      : undefined,
    social: social ? { facebook, twitter, instagram } : undefined,
    orderAheadEnabled,
    orderAtTableEnabled,
    orderDeliveryEnabled,
    timezone,
  };
}
